import { Component } from 'react';
import { toast } from 'react-toastify';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Show user-friendly error message
    toast.error('Something went wrong. Please refresh the page.');

    // Log error to analytics if available
    if (window.gtag) {
      window.gtag('event', 'exception', {
        description: error.toString(),
        fatal: false
      });
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <div style={styles.content}>
            <h2 style={styles.title}>Oops! Something went wrong</h2>
            <p style={styles.message}>
              We're sorry for the inconvenience. Please try refreshing the page.
            </p>
            <button onClick={this.handleReload} style={styles.button}>
              Refresh Page
            </button>
            {process.env.NODE_ENV === 'development' && (
              <details style={styles.details}>
                <summary>Error Details (Development)</summary>
                <pre style={styles.errorText}>
                  {this.state.error && this.state.error.toString()}
                  <br />
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '2rem',
    background: '#f9fafb',
  },
  content: {
    textAlign: 'center',
    maxWidth: '500px',
    padding: '2rem',
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '1rem',
  },
  message: {
    color: '#6b7280',
    marginBottom: '2rem',
    lineHeight: '1.5',
  },
  button: {
    padding: '0.75rem 1.5rem',
    background: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  details: {
    marginTop: '2rem',
    textAlign: 'left',
  },
  errorText: {
    background: '#f3f4f6',
    padding: '1rem',
    borderRadius: '4px',
    fontSize: '0.875rem',
    overflow: 'auto',
    maxHeight: '200px',
  },
};

export default ErrorBoundary;